import { Helmet } from 'react-helmet-async';

import { ONETRUST_ENABLED, ONETRUST_KEY } from '@constants/config';

const OneTrust = () => {
  return (
    <>
      {process.env.E2E_TESTS !== 'true' && ONETRUST_ENABLED && (
        <Helmet>
          <script
            src="https://cdn-ukwest.onetrust.com/scripttemplates/otSDKStub.js"
            type="text/javascript"
            data-domain-script={ONETRUST_KEY}
          />
          <script type="text/javascript">{`function OptanonWrapper() {}`}</script>
        </Helmet>
      )}
    </>
  );
};

export default OneTrust;
